module.exports = __webpack_public_path__ + "static/Danzza-Regular-84b29802f0728d711815edb447c90e36.woff2";